<span [className]="convertedModes()"> {{ modesText() }} </span>
